// extracted by mini-css-extract-plugin
export default {"dFlex":"ccf-text-editor_dFlex__rmUSp","wrapperClassName":"ccf-text-editor_wrapperClassName__vURw9"};